var _path, _path2, _circle, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktopWarningIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9141 12.7031C16.1797 12.7031 11.4961 17.3867 11.4961 23.1211V64.7891C11.4961 70.5196 16.1797 75.2031 21.9141 75.2031H46.9141V83.5351H30.2461C29.0938 83.5351 28.1641 84.4687 28.1641 85.621C28.1641 86.7694 29.0938 87.703 30.2461 87.703H67.7461C68.8984 87.703 69.8281 86.7694 69.8281 85.621C69.8281 84.4687 68.8984 83.5351 67.7461 83.5351H51.0781V75.2031H76.0781C81.8125 75.2031 86.4961 70.5195 86.4961 64.7851V23.1211C86.4961 17.3867 81.8125 12.7031 76.0781 12.7031H21.9141ZM21.9141 16.8711H76.0821C79.5782 16.8711 82.3282 19.6211 82.3282 23.1211V58.5351H15.6642V23.1211C15.6642 19.6211 18.4141 16.8711 21.9141 16.8711ZM15.6641 62.7031H82.3321V64.7851C82.3282 68.2851 79.5782 71.0351 76.0782 71.0351H21.9142C18.4142 71.0351 15.6642 68.2851 15.6642 64.7851L15.6641 62.7031Z",
    fill: "#0F172A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.414 21.0313C58.2617 21.0313 57.3281 21.9649 57.3281 23.1172C57.3281 23.668 57.5508 24.1992 57.9414 24.5899C58.332 24.9805 58.8594 25.1993 59.4141 25.1993H76.0821H76.0782C76.6329 25.1993 77.1602 24.9806 77.5509 24.5899C77.9415 24.1993 78.1642 23.668 78.1642 23.1172C78.1642 22.5625 77.9415 22.0352 77.5509 21.6445C77.1603 21.2539 76.6329 21.0312 76.0782 21.0312L59.414 21.0313Z",
    fill: "#FC9D03"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.6562,
    cy: 18.1016,
    r: 17.8672,
    fill: "#FEF3E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6562 19.102C26.6562 24.102 23.1562 26.602 18.9963 28.052C18.7784 28.1258 18.5418 28.1223 18.3263 28.042C14.1562 26.602 10.6562 24.102 10.6562 19.102V12.102C10.6562 11.8368 10.7616 11.5824 10.9491 11.3949C11.1367 11.2074 11.391 11.102 11.6562 11.102C13.6562 11.102 16.1562 9.90201 17.8962 8.38201C18.1081 8.20101 18.3776 8.10156 18.6562 8.10156C18.9349 8.10156 19.2044 8.20101 19.4163 8.38201C21.1663 9.91201 23.6562 11.102 25.6562 11.102C25.9215 11.102 26.1758 11.2074 26.3634 11.3949C26.5509 11.5824 26.6562 11.8368 26.6562 12.102V19.102Z",
    stroke: "#FC9D03",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6562 14.1016V18.1016",
    stroke: "#FC9D03",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6562 22.1016H18.6663",
    stroke: "#FC9D03",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopWarningIcon);
export default __webpack_public_path__ + "static/media/DesktopWarningIcon.7ecacba1249ed2f3509eeb2e8abc8b5f.svg";
export { ForwardRef as ReactComponent };